import React from 'react';
import '../assets/styles.css';

export default function ServicesSectionD() {
  const virtualPrograms = [
    {
      id: 1,
      title: "Arts & Crafts (Decorative Butterflies Using Coffee Filter)",
      videoId: "Bx57ukbvfW4",
      embedUrl: "https://www.youtube.com/embed/Bx57ukbvfW4?si=er8UyQ7BR_3fklub"
    },
    {
      id: 2,
      title: "Arts & Crafts (Spring Table Decor)",
      videoId: "jhyyeuOidl8",
      embedUrl: "https://www.youtube.com/embed/jhyyeuOidl8?si=sQz0vAGENxIu6lT-"
    },
    {
      id: 3,
      title: "Arts & Crafts (Paper Mache)",
      videoId: "cQ4vOkCmBLk",
      embedUrl: "https://www.youtube.com/embed/cQ4vOkCmBLk?si=6Wy4QMiyg8nalpzc"
    }
  ];

  return (
    <div>
      <div className="overflow-hidden bg-white py-12 sm:py-16 lg:py-20 xl:py-24" data-aos="fade-left" data-aos-duration="1000">
        
        {/* Section Header - Enhanced responsive design */}
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl text-black mb-4 sm:mb-6 lg:mb-8 newsreader leading-tight">
              Virtual Programming
            </h2>
            <p className="text-sm sm:text-base lg:text-md xl:text-md text-black leading-relaxed max-w-4xl mx-auto px-4 sm:px-0">
              Piedmont Adult Day Program's Virtual Programming started in April 2022. This program aims to bridge the other online learning modality so that it can reach broader individuals and better the learning experience of everyone.
            </p>
          </div>
        </div>

        {/* Video Grid - Enhanced responsive layout */}
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 sm:gap-8 lg:gap-10 justify-items-center">
            {virtualPrograms.map((program, index) => (
              <div
                key={program.id}
                className="w-full max-w-sm bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
                data-aos="fade-up"
                data-aos-duration="2000"
                data-aos-delay={index * 200}
              >
                {/* Video Container - Enhanced responsive sizing with proper iframe responsiveness */}
                <div className="relative h-48 sm:h-56 lg:h-60 xl:h-64 bg-gray-100 overflow-hidden">
                  {/* Responsive iframe wrapper */}
                  <div className="absolute inset-0 w-full h-full">
                    <iframe
                      className="absolute top-0 left-0 w-full h-full"
                      src={program.embedUrl}
                      title={program.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                      loading="lazy"
                    />
                  </div>
                  
                  {/* Loading overlay */}
                  <div className="absolute inset-0 bg-gray-200 flex items-center justify-center opacity-0 group-hover:opacity-0 transition-opacity duration-300 pointer-events-none">
                    <svg className="w-8 h-8 text-gray-400 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                  </div>
                </div>

                {/* Card Content - Enhanced spacing and typography */}
                <div className="p-4 sm:p-5 lg:p-6">
                  <h3 className="text-sm sm:text-base lg:text-lg font-medium text-gray-900 leading-relaxed text-center">
                    {program.title}
                  </h3>
                  
                  {/* Additional metadata */}
                  <div className="mt-3 sm:mt-4 flex items-center justify-center gap-2 text-xs sm:text-sm text-gray-500">
                    <svg className="w-3 h-3 sm:w-4 sm:h-4 text-red-600" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M23.498 6.186a3.003 3.003 0 00-2.116-2.127C19.6 3.5 12 3.5 12 3.5s-7.6 0-9.382.559A3.003 3.003 0 00.502 6.186C0 7.977 0 12 0 12s0 4.023.502 5.814a3.003 3.003 0 002.116 2.127C4.4 20.5 12 20.5 12 20.5s7.6 0 9.382-.559a3.003 3.003 0 002.116-2.127C24 16.023 24 12 24 12s0-4.023-.502-5.814zM9.75 15.5v-7L15.75 12l-6 3.5z"/>
                    </svg>
                    <span>YouTube Video</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}